import React from "react";
import { Button } from "@mui/material";
import { Assessment } from "@mui/icons-material";

import TransmissionReportLogUserModal from "./modal/TransmissionReportLogUserModal";
import useTransmissionReportLog from "./useTransmissionReportLog";

const TransmissionReportLog = () => {
  const { showUserModal, setShowUserModal, onClose } =
    useTransmissionReportLog();

  return (
    <>
      <div className="d-flex flex-end ">
        <Button
          variant="contained"
          color="secondary"
          onClick={() => {
            setShowUserModal(true);
          }}
          startIcon={<Assessment />}
        >
          User Transmission Progress Report
        </Button>
      </div>

      {showUserModal && <TransmissionReportLogUserModal onClose={onClose} />}
    </>
  );
};

export default TransmissionReportLog;
